import styled from "styled-components";
import { theme } from '../../../theme'
// import { FaBullhorn } from "react-icons/fa";
import { Button } from '../../button'
import { Link } from "react-router-dom";
import { MdCreate, MdDelete, MdHome, MdMoreVert } from "react-icons/md";

const Item = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
//   padding-left: 1.6rem;
    padding: 1.5rem 0;
    border-bottom: 1px solid rgb(216 216 216 / 37%);
`

const ImageContainer = styled.div`
    width: 3.5rem;
    height: 3.5rem;
    color: ${theme.colors.mainBlue};
    background: rgba(33, 150, 243, 0.44);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
        height: 2.4rem;
        width: 2.4rem;
    }
`
const LongTextContainer = styled.div`
@media only screen and (max-width: 768px) {
    display: none;
}

    p {
        font-weight: 400;
        font-size: 1.2rem;
        color: #979797;
        white-space: nowrap; 
        width: 35.6rem; 
        overflow: hidden;
        text-overflow: ellipsis; 
    }
`


const TextContainer = styled.div`
    .main-header {
        font-weight: 700;
        font-size: 1.4rem;
        color: #3B3B42;
    }
`
const ActionsDiv = styled.div`
display: flex;
align-items: center;
gap: 1.473rem;
.icon {
        cursor: pointer;
        display: flex;
        color: #D6D7D8;
        width: 1.7rem;
    height: 1.7rem;

    svg {
        width: 100%;
        height: 100%;
    }
    }
`

const EventItem = () => {
    return (
        <Item>
            <ImageContainer>
                <MdHome />
            </ImageContainer>
            <TextContainer>
                <p className="main-header">Temple College</p>
            </TextContainer>
            <LongTextContainer>
                <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Natus, corrupti veritatis fuga iste maiores nulla dignissimos ipsam labore quos, laborum sapiente aut iure quod? Temporibus praesentium voluptates reprehenderit incidunt adipisci hic, quo quaerat, saepe libero fugiat eveniet ipsam? Nostrum quam ipsa mollitia debitis ad obcaecati iste totam unde veritatis dolor.</p>
            </LongTextContainer>
            <ActionsDiv>
                <span className="icon"><MdCreate /></span>
                <span className="icon"><MdDelete /></span>
                <span className="icon"><MdMoreVert /></span>
            </ActionsDiv>

        </Item >
    )
}

export default EventItem
